module.exports = __webpack_public_path__ + "static/media/avatar_small.5f5a0244.png";